<template>
    <div class="login-tip">
        <img :src="loginIcon" width="30" alt="">
        <span class="tip-text">{{$t('mobile.moreService')}}</span>
        <el-button type="primary" size="small" :round="true"  @click="goLogin">{{$t('mobile.toLogin')}}</el-button>
    </div>
</template>

<script>
import loginIcon from '@/assets/img/mobile/login.png';
export default {
    name: 'LoginTip',
    data() {
        return {
            loginIcon,
        }
    },
    methods: {
        goLogin() {
            // 跳转到登录页面
            this.$router.push({ path: '/h5/login' });
        }
    }
}
</script>

<style scoped>
.login-tip {
    position: fixed;
    left: 20px;
    right: 20px;
    bottom: 80px; /* 略高于 footer，假设 footer 高度为 56px */
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0px 0px 10px 2px rgba(0,0,0,0.3);
    padding: 10px 8px;
    z-index: 1000;
}

.tip-text {
    flex: 1;
    font-size: 14px;
    color: #333;
    margin: 0 10px;
    font-weight: bold;
}

.login-btn {
    background: #1890ff;
    color: #fff;
    border: none;
    border-radius: 20px;
    padding: 6px 20px;
    font-size: 15px;
    cursor: pointer;
    outline: none;
    transition: background 0.2s;
}

.login-btn:hover {
    background: #40a9ff;
}
</style></div>